import React, { Component } from 'react';
import './App.css';
import Header from './components/header/header';
import Hero from './components/hero/hero';
import About from './components/about/about';
import Services from './components/services/services';
import Portfolio from './components/portfolio/portfolio';
import Blog from './components/blog/blog';
import Contact from './components/contact/contact';
import Footer from './components/footer/footer';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header/>
        <Hero/>
        <About/>
        <Services/>
        <Portfolio/>
        <Blog/>
        <Contact/>
        <Footer/>
      </div>
    );
  }
}

export default App;
